import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";

const RELOCATION_ORDER_RESOURCE = "relocation-order" as const;
const RELOCATION_ORDER_FLOW_RESOURCE = "relocation-order/flow" as const;
export const RELOCATION_ORDER_FLOW_CANCEL_OPERATION = "cancel" as const;
export const RELOCATION_ORDER_FLOW_CANCEL_API_PATH =
  `/v1/${RELOCATION_ORDER_FLOW_RESOURCE}/{uuid}/${RELOCATION_ORDER_FLOW_CANCEL_OPERATION}` as const;

export type CancelRelocationOrderResponse =
  paths[typeof RELOCATION_ORDER_FLOW_CANCEL_API_PATH]["patch"]["responses"][200]["content"]["application/json"];

export const useRelocationOrderFlowCancelMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<CancelRelocationOrderResponse, Error, { uuid: string }>({
    mutationFn: async ({ uuid }) => {
      const response = await alphartisApiAxios.patch<CancelRelocationOrderResponse>(
        `/v1/${RELOCATION_ORDER_FLOW_RESOURCE}/${uuid}/${RELOCATION_ORDER_FLOW_CANCEL_OPERATION}`,
      );
      return response.data;
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [RELOCATION_ORDER_RESOURCE],
      });
    },
  });
};
